import React from 'react';

export const FlagITIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 900 600" // Standard 3:2 ratio
    {...props}
  >
    <rect width="900" height="600" fill="#FFFFFF" rx="2"/> {/* White field (center) */}
    <rect width="300" height="600" fill="#009246" /> {/* Green stripe */}
    <rect x="600" width="300" height="600" fill="#CE2B37" /> {/* Red stripe */}
  </svg>
);